export function modelPriceGapTextV1018(language) {
  return language?.startsWith('zh') ? {
    toggle: '仅显示未标基础价的模型',
    title: '未标基础价模型',
    scope: '含停用渠道及待接入模型',
    missing: '未配置基础价',
    scheduled: '基础价待生效',
    next: '生效时间',
    offline: '无启用渠道',
    channels: '已登记渠道',
    empty: '所有已登记模型均已配置当前基础价',
    base: '设置基础价',
  } : {
    toggle: 'Only models missing a current base price',
    title: 'Models missing base prices',
    scope: 'Includes disabled channels and unbound models',
    missing: 'Base price not configured',
    scheduled: 'Base price scheduled',
    next: 'Effective at',
    offline: 'No enabled channels',
    channels: 'Registered channels',
    empty: 'All registered models have a current base price',
    base: 'Set base price',
  };
}
